import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import {baseconfig,rsaBasicModuleConfig} from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'
export const applyauditModel = {

    // 申报审核-乡级待审核--CGX
    async applyaudit1list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'dfsjfksdkf',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyaudit1list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-乡级待审核-申请人列表--CGX
    async applyaudit1userlist(page,page_size,key_words,policy_measure_id,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + 'dfms2klkl',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit1userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words+ '&region_level=' + region_level + '&region_id=' + region_id  + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },
    //申报审核-批量审核--CGX
    async applybatchaudit(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason,mark) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            is_audit_pass: is_audit_pass,
            no_pass_reason_id:no_pass_reason_id,
            no_pass_reason: no_pass_reason,
            mark:mark,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_id)+ String(is_audit_pass) + 'sdajfkj',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applybatchaudit', 'post', qs.stringify(paras), null)
    },
    // 申报审核-乡级待审核-申请人列表-导出公示列表 HYT
    
}
export const applyaudit2Model = {

    // 申报审核-乡级待提交--CGX
    async applyaudit2list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'fnskfgd',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyaudit2list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-乡级待提交-申请人列表--CGX
    async applyaudit2userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfsmkfj',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit2userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id+ '&id_number=' + id_number , 'get', null, null)
    },
    //申报审核-批量提交审核--CGX
    async applybatchsubmitforapprocal(apply_record_ids,user_ids,policy_measure_id,mark) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            mark: mark,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_id)+ String(mark) + 'fsmkfs',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applybatchsubmitforapprocal', 'post', qs.stringify(paras), null)
    },
     //申报审核-批量修改公示状态--CGX/applybatcheditpublicitystatus
     async applybatcheditpublicitystatus(apply_record_ids,user_ids,policy_measure_id,gallery_json,publicity_status) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            gallery_json: gallery_json,
            publicity_status:publicity_status,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_id)+ String(publicity_status) + 'dfsnkj',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applybatcheditpublicitystatus', 'post', qs.stringify(paras), null)
    },
    //申报审核-重审--CGX   /applyrepeataudit
    async applyrepeataudit(apply_record_id,user_id,policy_measure_id,is_audit_pass,no_pass_reason_id,no_pass_reason) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            user_id: user_id,
            apply_record_id: apply_record_id,
            is_audit_pass: is_audit_pass,
            no_pass_reason_id:no_pass_reason_id,
            no_pass_reason:no_pass_reason,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_id) + String(user_id) + String(policy_measure_id)+ String(is_audit_pass) + 'fmwkjkrew',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyrepeataudit', 'post', qs.stringify(paras), null)
    },
    
}
export const applyaudit3Model = {
    // 申报审核-乡级待审核--CGX
    async applyaudit3list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'dfnsakj',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyaudit3list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-乡级待审核-申请人列表--CGX
    async applyaudit3userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfnsjfsban',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit3userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },
    //申报审核-批量审核--CGX   //applybatchapprove
    async applybatchapprove(mark,type,policy_measure_ids,apply_record_ids,user_ids,policy_measure_id,is_approve_pass,approve_opinion_id,approve_opinion) {
        const adminToken = store.getters.adminID
        var paras = {
            mark: mark,
            type: type,
            policy_measure_ids: policy_measure_ids,
            policy_measure_id: policy_measure_id,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            is_approve_pass: is_approve_pass,
            approve_opinion_id:approve_opinion_id,
            approve_opinion:approve_opinion,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(mark) + String(type) + String(is_approve_pass) + 'GKRO%sdaj',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applybatchapprove', 'post', qs.stringify(paras), null)
    },
}
export const applyaudit4Model = {
    // 申报审核-乡级驳回待审--CGX
    async applyaudit4list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'fsnjakf',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyaudit4list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-乡级驳回待审-申请人列表--CGX
    async applyaudit4userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dg@srti',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit4userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id+ '&id_number=' + id_number , 'get', null, null)
    },
}
export const applyaudit5Model = {
    // 申报审核-区级待审核--CGX
    async applyaudit5list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'dfsjfksdkf',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyaudit5list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-区级待审核-申请人列表--CGX
    async applyaudit5userlist(page,page_size,key_words,policy_measure_id,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + 'dfms2klkl',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit5userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words+ '&region_level=' + region_level + '&region_id=' + region_id  + '&policy_measure_id=' + policy_measure_id+ '&id_number=' + id_number , 'get', null, null)
    },
}
export const applyaudit6Model = {
    // 申报审核-区级待提交--CGX
    async applyaudit6list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'fnskfgd',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyaudit6list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-区级待提交-申请人列表--CGX
    async applyaudit6userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfsmkfj',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit6userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },
}
export const applyaudit7Model = {
    // 申报审核-区级待审核--CGX
    async applyaudit7list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'dfnsakj',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyaudit7list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-区级待审核-申请人列表--CGX
    async applyaudit7userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfnsjfsban',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit7userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id+ '&id_number=' + id_number , 'get', null, null)
    },
}
export const applyaudit8Model = {
    // 报审核-区级驳回待审--CGX
    async applyaudit8list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'fsnjakf',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyaudit8list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-区级驳回待审-申请人列表--CGX
    async applyaudit8userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dg@srti',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit8userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id+ '&id_number=' + id_number , 'get', null, null)
    },
}
export const applyauditfinishModel = {
   
   // 申报审核-已完成-申请人列表--CGX
    async applyauditfinishuserlist(page,page_size,policy_measure_id,key_words,account_nature,year,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(account_nature) + String(year) + String(enjoy_census_region_id) + String(current_census_region_id) + 'dfmskjjdis',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditfinishuserlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&account_nature=' + account_nature + '&year=' + year+ '&enjoy_census_region_level=' + enjoy_census_region_level+ '&enjoy_census_region_id=' + enjoy_census_region_id+ '&current_census_region_level=' + current_census_region_level+ '&current_census_region_id=' + current_census_region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },
    //申报审核-已完成-转年审--CGX  //rewardchangeannualreview
    async rewardchangeannualreview(apply_record_ids,user_ids,policy_measure_ids,mark) {
        const adminToken = store.getters.adminID
        var paras = {
            mark: mark,
            policy_measure_ids: policy_measure_ids,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_ids) + String(mark)+ 'dfmserjk',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardchangeannualreview', 'post', qs.stringify(paras), null)
    },
    // 导出/auditlistword
    async auditlistword(policy_measure_id,key_words,account_nature,year,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~cv1QYXCRIPi',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'auditlistword?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign)  + '&key_words=' + key_words + '&account_nature=' + account_nature + '&year=' + year+ '&enjoy_census_region_level=' + enjoy_census_region_level+ '&enjoy_census_region_id=' + enjoy_census_region_id+ '&current_census_region_level=' + current_census_region_level+ '&current_census_region_id=' + current_census_region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },
    // async auditlistword(apply_record_ids) {
    //     const adminToken = store.getters.adminID
    //     var paras = {
    //         timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
    //         _sign: rsa.signString(baseconfig.v + adminToken + '~cv1QYXCRIPi',rsaBasicModuleConfig.clientPrivateKey),
    //     }
    //     return await httpRequest(baseUrl.basic + 'auditlistword?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&apply_record_ids=' + apply_record_ids, 'get', null, null)
    //  },
}
export const applypublicitygalleryinfolistModel = {
   
    // /applypublicitygalleryinfolist 公式图集
     async applypublicitygalleryinfolist(page,pagesize,apply_record_id,gallery_type) {
         const adminToken = store.getters.adminID
         var paras = {
             timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
             _sign: rsa.signString(baseconfig.v + adminToken +"~A6564d",rsaBasicModuleConfig.clientPrivateKey),
         }
         return await httpRequest(baseUrl.basic + 'applypublicitygalleryinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize  + '&apply_record_id=' + apply_record_id + '&gallery_type=' + gallery_type , 'get', null, null)
     },
}

// 村级
export const applyaudit9Model = {
    // 申报审核-村级待审核--CGX
    async applyauditvillage1list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'dfsjfksdkf',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyauditvillage1list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-村级待审核-申请人列表--CGX
    async applyauditvillage1userlist(page,page_size,key_words,policy_measure_id,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + 'dfms2klkl',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditvillage1userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words+ '&region_level=' + region_level + '&region_id=' + region_id  + '&policy_measure_id=' + policy_measure_id+ '&id_number=' + id_number , 'get', null, null)
    },
}
export const applyaudit10Model = {
    // 申报审核-村级待提交--CGX
    async applyauditvillage2list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'fnskfgd',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyauditvillage2list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-村级待提交-申请人列表--CGX
    async applyauditvillage2userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfsmkfj',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditvillage2userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },
}
export const applyaudit11Model = {
    // 申报审核-村级待审核--CGX
    async applyauditvillage3list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'dfnsakj',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyauditvillage3list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-村级待审核-申请人列表--CGX
    async applyauditvillage3userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfnsjfsban',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditvillage3userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id+ '&id_number=' + id_number , 'get', null, null)
    },
}
export const applyaudit12Model = {
    // 报审核-区级驳回待审--CGX
    async applyauditvillage4list(page,page_size,key_words) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + 'fsnjakf',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'applyauditvillage4list?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words , 'get', null, null)
    },
   // 申报审核-区级驳回待审-申请人列表--CGX
    async applyauditvillage4userlist(page,page_size,policy_measure_id,key_words,region_level,region_id,id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dg@srti',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditvillage4userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size  + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id+ '&id_number=' + id_number , 'get', null, null)
    },
}